import { DISABLE_FASTLY_CHALLENGE_COOKIE_NAME } from '@spa/lib/configs/fastlyChallengeEnabled';
import { FEATURE_TOGGLE_COOKIE_NAME } from '@spa/lib/feature-toggles/cookieService';
import experimentsSettings from '@spa/lib/configs/experimentsSettings';
import isAuthSessionCookie from '@spa/lib/auth/isAuthSessionCookie';

const sessionCookieName = 'session';
const cartsCookieName = 'CARTS_COOKIE';
const disableExternalScriptsCookieName = 'disable-external-scripts';

const nonCacheableExperimentCookies = new Set(
  Object.keys(experimentsSettings).map((id) => `bst_experiment_${id}_b`)
);

const baseNonCacheable = new Set([
  sessionCookieName,
  cartsCookieName,
  FEATURE_TOGGLE_COOKIE_NAME,
  disableExternalScriptsCookieName,
  DISABLE_FASTLY_CHALLENGE_COOKIE_NAME
]);

const isAnonymousCacheableCookieName = (name: string): boolean => {
  return !(
    baseNonCacheable.has(name) ||
    nonCacheableExperimentCookies.has(name) ||
    isAuthSessionCookie(name)
  );
};

export default isAnonymousCacheableCookieName;
